import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass([
         'dashboard__chart',
         'grid__cell',
       ])
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chart = _resolveComponent("v-chart")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createBlock(_component_v_chart, {
              key: 0,
              class: "chart",
              option: _ctx.option
            }, null, 8, ["option"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}